import { JSONParser } from '@streamparser/json';
class PartialJSONStreamParser {
    parser;
    rootObject = {};
    partialFlags = {};
    allValues = [];
    hasCompleteJSON = false; // 是否解析到完整JSON
    constructor() {
        this.parser = new JSONParser({
            emitPartialTokens: true, // 启用部分token解析
            emitPartialValues: true, // 启用部分值解析
        });
        // 设置解析回调
        this.parser.onValue = (parsedElementInfo) => {
            console.log('onValue called:', parsedElementInfo); // 调试日志
            this.allValues.push(parsedElementInfo);
            const { value, key, parent, stack, partial } = parsedElementInfo;
            // 处理所有有意义的值
            if (value !== undefined) {
                if (key === undefined) {
                    // 根级对象
                    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                        this.rootObject = { ...this.rootObject, ...value };
                        this.hasCompleteJSON = partial !== true;
                        console.log('Root object merged:', JSON.stringify(this.rootObject, null, 2)); // 调试日志
                    }
                }
                else {
                    // 有key的值，构建路径并设置
                    const pathParts = this.getPathFromStack(stack);
                    pathParts.push(key);
                    this.setValueAtPath(this.rootObject, pathParts, value);
                    const pathKey = pathParts.join('.');
                    this.partialFlags[pathKey] = partial === true;
                    console.log('Set value at path:', pathKey, 'value:', value, 'partial:', partial); // 调试日志
                    console.log('Current root object:', JSON.stringify(this.rootObject, null, 2)); // 调试日志
                }
            }
        };
    }
    /**
     * 从stack获取路径
     */
    getPathFromStack(stack) {
        const path = [];
        if (stack && Array.isArray(stack)) {
            for (const item of stack) {
                if (item && typeof item === 'object' && item.key !== undefined) {
                    path.push(item.key);
                }
            }
        }
        return path;
    }
    /**
     * 在指定路径设置值
     */
    setValueAtPath(obj, path, value) {
        let current = obj;
        // 遍历路径，确保所有中间对象都存在
        for (let i = 0; i < path.length - 1; i++) {
            const key = path[i];
            const nextKey = path[i + 1];
            // 判断下一个key是否是数字，如果是则需要数组
            const isNextKeyNumeric = /^\d+$/.test(nextKey);
            if (!(key in current) || typeof current[key] !== 'object' || current[key] === null) {
                current[key] = isNextKeyNumeric ? [] : {};
            }
            else if (isNextKeyNumeric && !Array.isArray(current[key])) {
                // 如果下一个key是数字但当前值不是数组，转换为数组
                current[key] = [];
            }
            else if (!isNextKeyNumeric && Array.isArray(current[key])) {
                // 如果下一个key不是数字但当前值是数组，转换为对象
                current[key] = {};
            }
            current = current[key];
        }
        // 设置最终值
        const lastKey = path[path.length - 1];
        current[lastKey] = value;
    }
    /**
     * 解析JSON片段并返回当前解析结果
     * @param chunk - JSON字符串片段
     * @returns 解析结果包含数据、部分状态标记和完整性信息
     */
    parse(chunk) {
        try {
            this.parser.write(chunk);
            return this.getResult();
        }
        catch (error) {
            console.log('Parse error:', error); // 调试日志
            return this.getResult();
        }
    }
    getResult() {
        const result = { ...this.rootObject };
        const metadata = { ...this.partialFlags };
        // isPartialComplete: 所有字段是否都完整解析了
        const isPartialComplete = Object.keys(metadata).length === 0
            || Object.values(metadata).every(isPartial => !isPartial);
        return {
            data: result,
            partial: metadata,
            isComplete: this.hasCompleteJSON, // 是否解析了完整的JSON
            isPartialComplete, // 所有字段是否都完整
        };
    }
    /**
     * 获取所有解析到的值（用于调试）
     * @returns 所有解析值的数组
     */
    getAllValues() {
        return this.allValues;
    }
    /**
     * 重置解析器状态，开始解析新的JSON
     */
    reset() {
        this.rootObject = {};
        this.partialFlags = {};
        this.allValues = [];
        this.hasCompleteJSON = false;
        this.parser = new JSONParser({
            emitPartialTokens: true,
            emitPartialValues: true,
        });
        this.parser.onValue = (parsedElementInfo) => {
            console.log('onValue called:', parsedElementInfo);
            this.allValues.push(parsedElementInfo);
            const { value, key, parent, stack, partial } = parsedElementInfo;
            // 处理所有有意义的值
            if (value !== undefined) {
                if (key === undefined) {
                    // 根级对象
                    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                        this.rootObject = { ...this.rootObject, ...value };
                        this.hasCompleteJSON = partial !== true;
                        console.log('Root object merged:', JSON.stringify(this.rootObject, null, 2));
                    }
                }
                else {
                    // 有key的值，构建路径并设置
                    const pathParts = this.getPathFromStack(stack);
                    pathParts.push(key);
                    this.setValueAtPath(this.rootObject, pathParts, value);
                    const pathKey = pathParts.join('.');
                    this.partialFlags[pathKey] = partial === true;
                    console.log('Set value at path:', pathKey, 'value:', value, 'partial:', partial);
                    console.log('Current root object:', JSON.stringify(this.rootObject, null, 2));
                }
            }
        };
    }
}
/**
 * 创建流式JSON解析器实例
 * @returns 支持部分JSON解析的解析器实例
 */
function createPartialJsonParser() {
    return new PartialJSONStreamParser();
}
export { createPartialJsonParser, PartialJSONStreamParser };
